import { COLLECTIONS } from "constants/action-types";
import { EventTypes } from "redux-segment";

export const collectionHistoryPush = (payload) => ({
    payload,
    type: COLLECTIONS.COLLECTION.HISTORY.PUSH,
});

export const collectionHistoryUpdate = (undo, redo) => ({
    payload: {
        redo,
        undo,
    },
    type: COLLECTIONS.COLLECTION.HISTORY.UPDATE,
});

export const collectionHistoryUndo = (collectionId: string) => ({
    meta: {
        analytics: EventTypes.track,
    },
    payload: {
        collectionId,
    },
    type: COLLECTIONS.COLLECTION.HISTORY.UNDO,
});

export const collectionHistoryRedo = (collectionId: string) => ({
    meta: {
        analytics: EventTypes.track,
    },
    payload: {
        collectionId,
    },
    type: COLLECTIONS.COLLECTION.HISTORY.REDO,
});

export const collectionHistoryClear = () => ({
    type: COLLECTIONS.COLLECTION.HISTORY.CLEAR,
});
